'use client'
/* eslint-disable react-hooks/exhaustive-deps */
import { useDrawerControlContext } from '@/context/DrawerControlContext'
import { UseGrocerContext } from '@/context/GrocerContextV3'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useCallback, useEffect } from 'react'
import useCartActions from './useCartActions'

const useCartDrawer = () => {
  const { setCallforgotSomething, forgotSomethingProducts } = UseGrocerContext()
  const { isLogged } = UseLoggedContext()
  const { onInitOpenDrawer, setOpenDrawer, setOnCheckoutClick } =
    useDrawerControlContext()
  const { headerData, screenNames } = useHeaderDataContext()
  const { onCheckoutClick } = useCartActions({
    setOpenDrawer,
    forgotSomethingProducts,
  })

  useEffect(() => {
    setOnCheckoutClick(() => onCheckoutClick)
  }, [onCheckoutClick])

  const onOpenCart = useCallback(() => {
    onInitOpenDrawer(true)
    if (isLogged) {
      setCallforgotSomething(true)
    }
  }, [isLogged, screenNames, headerData])

  return { onOpenCart }
}

export default useCartDrawer
